import React, { lazy } from 'react'
import increaseOriginalValueRoutes from './IncreaseOriginalValue/IncreaseOriginalValueRoutes'
import provisionImpairmentRoutes from './ProvisionImpairment/ProvisionImpairmentRoutes'
import residualValueRoutes from './ResidualValue/ResidualRoutes'
import provisionImpairmentReversalRoutes from './ProvisionImpairmentReversal/ProvisionImpairmentReversalRoutes'
import usefulLifeRoutes from './UsefulLife/UsefulLifeRoutes'
import decreaseOriginalValueRoutes from './DecreaseOriginalValue/DecreaseOriginalValueRoutes'
import changeAssetCategoryRoutes from './ChangeAssetCategory/ChangeAssetCategoryRoutes'
import depreciationMethodRoutes from './DepreciationMethod/DepreciationMethodRoutes'
import totalDepreciationRoutes from './TotalDepreciation/TotalDepreciationRoutes'
import assetTransferByDepartmentRoutes from './AssetTransferByDepartment/AssetTransferByDepartmentRoutes'
import changeApportionmentRoutes from './ChangeApportionment/ChangeApportionmentRoutes'
import assetTransferByLocationRoutes from './AssetTransferByLocation/AssetTransferByLocationRoutes'

const AssetsChangeSubmenu = lazy(() =>
  import('./AssetsChangeSubmenu').then(module => ({
    default: module.AssetsChangeSubmenu,
  }))
)

const assetsChangeSubmenuRoutes = [
  {
    props: { exact: true, path: '/fixed-assets/:CompanyID/assets-change' },
    component: <AssetsChangeSubmenu />,
  },
  ...increaseOriginalValueRoutes,
  ...decreaseOriginalValueRoutes,
  ...provisionImpairmentRoutes,
  ...provisionImpairmentReversalRoutes,
  ...assetTransferByDepartmentRoutes,
  ...residualValueRoutes,
  ...usefulLifeRoutes,
  ...changeAssetCategoryRoutes,
  ...depreciationMethodRoutes,
  ...totalDepreciationRoutes,
  ...changeApportionmentRoutes,
  ...assetTransferByLocationRoutes,
]

export default assetsChangeSubmenuRoutes
